/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: FetchArgs;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: FetchArgs;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: <TData, TStatus extends number>(
        response: FetchResponse<TData, TStatus>,
      ) => FetchResponse<TData, TStatus> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    const uniqMiddlewares = <
      T extends
        | Configuration["requestMiddlewares"]
        | Configuration["responseMiddlewares"],
    >(
      oldMiddlewares: T,
      newMiddlewares: T,
    ): T => {
      return [
        ...(oldMiddlewares?.filter(
          middleware => !newMiddlewares?.some(m => m.name === middleware.name),
        ) ?? []),
        ...(newMiddlewares ?? []),
      ] as T;
    };
  
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: uniqMiddlewares(CONFIG.requestMiddlewares, configuration.requestMiddlewares),
      responseMiddlewares: uniqMiddlewares(CONFIG.responseMiddlewares, configuration.responseMiddlewares),
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        request = middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<TData, TStatus extends number>(
    response: FetchResponse<TData, TStatus>,
  ): FetchResponse<TData, TStatus | 0> {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } satisfies FetchResponseOfError;
        }
        response = middlewareResponse;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchArgsOptions = Omit<RequestInit, "method" | "redirect" | "body">;

  export type FetchArgs = {
    url: string;
    options: RequestInit;
  }

  export type UriComponent = string | number | boolean;
  export type ParamsObject = {
    [key: string]: UriComponent | UriComponent[] | undefined | null;
  };

  export async function fetchJson<TData>(args: FetchArgs): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
    const errorResponse = (error: StandardError, status: number, args: FetchArgs) => {  
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    const errorStatus = (args: FetchArgs) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(errorResponse);
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } satisfies FetchResponseOfError;

        return processResponseWithMiddlewares(terminationResponse);
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response);
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              }
              if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val);
              }
          }
      });
    }
  
    return formData;
  }

  
function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = (request instanceof FormData) ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return { options: requestOptions, url: `${url}${maybeQueryString}` } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("POST", request, options, url, paramsObject));
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("GET", undefined, options, url, paramsObject));
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PUT", request, options, url, paramsObject));
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("DELETE", undefined, options, url, paramsObject));
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {}
) {
  return fetchJson<TResponse>(createRequest("PATCH", request, options, url, paramsObject));
}
// INFRASTRUCTURE END

export type FileResponse = {
  data: Blob;
  fileName?: string;
}

export type ApiProblemDetails = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export type ErrorDetail = {
	code: ErrorCode;
	message?: string | null;
};

export enum ErrorCode {
	Unspecified = "Unspecified",
	OutOfRange = "OutOfRange",
	NotFound = "NotFound",
	Invalid = "Invalid",
	Forbidden = "Forbidden",
	TooManyRequests = "TooManyRequests",
	Conflict = "Conflict",
	UnprocessableEntity = "UnprocessableEntity",
	NullOrEmpty = "NullOrEmpty",
	Unauthorized = "Unauthorized",
	ExternalProviderNotAvailable = "ExternalProviderNotAvailable",
	EntraIdReauthRequired = "EntraIdReauthRequired"
};

export type ProblemDetails = {
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export type EntityListOfUserListItemDto = {
	offset: number;
	limit: number;
	totalCount: number;
	items: UserListItemDto[];
	pageNumber: number;
	pageSize: number;
};

export type UserListItemDto = {
	userID: number;
	login: string;
	firstName: string;
	lastName: string;
	dateCreated: string;
};

export type UserDetailDto = {
	userID: number;
	login: string;
	email: string;
	firstName?: string | null;
	lastName?: string | null;
	lastSignInDate?: string | null;
	phone?: string | null;
	userIdentityProviders: IdentityProvider[];
	profilePicture?: string | null;
	status: UserStatus;
};

export enum IdentityProvider {
	Application = "Application",
	Google = "Google",
	BankID = "BankID",
	EntraId = "EntraId"
};

export enum UserStatus {
	Unknown = "Unknown",
	Active = "Active",
	WaitingForEmailConfirmation = "WaitingForEmailConfirmation"
};

export type CategoryResponse = {
	code: string;
	name: string;
	path: string;
	ancestors: CategoryAncestorResponse[];
	level: number;
};

export type CategoryAncestorResponse = {
	code: string;
	name: string;
};

export type PartnerResponse = {
	code: string;
	name: string;
	description?: string | null;
};

export type ProductResponse = {
	code: string;
	name: string;
	description?: string | null;
	categorizations: ProductCategorizationResponse[];
	partnerCode?: string | null;
	partnerName?: string | null;
};

export type ProductCategorizationResponse = {
	path: string;
	ancestors: CategoryAncestorResponse[];
};

export type SaveUserNotificationSettingsCommandResult = {};

export type UserNotificationUpdateRequest = {
	isEmailNotificationActive: boolean;
};

export type DocumentDataResponse = {
	documentDataId: string;
	documentId: string;
	dataType: DocumentDataType;
	jsonData: string;
	description?: string | null;
};

export enum DocumentDataType {
	Contract = "Contract"
};

export type EntityListOfDocumentResponse = {
	offset: number;
	limit: number;
	totalCount: number;
	items: DocumentResponse[];
	pageNumber: number;
	pageSize: number;
};

export type DocumentResponse = {
	documentId: string;
	documentType: string;
	dmsDocumentId: string;
	contractIds: string[];
	documentData?: DocumentDataResponse | null;
};

export enum DocumentExpandFields {
	DocumentData = "DocumentData"
};

export type CreateDocumentRequest = {
	documentType: string;
	dmsDocumentId: string;
	contractId: string;
};

export type UpdateDocumentRequest = {
	documentType: string;
	dmsDocumentId: string;
};

export type SimplifiedExtractedDocumentResponse = {
	contractId: string;
	documentInfo: SimplifiedDocumentInfoResponse;
};

export type SimplifiedDocumentInfoResponse = {
	product: ProductInfoResponse;
	institution: InstitutionInfoResponse;
};

export type ProductInfoResponse = {
	productCode: string;
	metadata: ProductMetadataResponse;
};

export type ProductMetadataResponse = {
	productCode: SimplifiedFieldMetadataResponse;
	productName: SimplifiedFieldMetadataResponse;
};

export type SimplifiedFieldMetadataResponse = {
	confidence: number;
	message?: string | null;
};

export type InstitutionInfoResponse = {
	institutionCode: string;
	metadata: InstitutionMetadataResponse;
};

export type InstitutionMetadataResponse = {
	institutionCode: SimplifiedFieldMetadataResponse;
	institutionName: SimplifiedFieldMetadataResponse;
};

export type EntityListOfContractResponse = {
	offset: number;
	limit: number;
	totalCount: number;
	items: ContractResponse[];
	pageNumber: number;
	pageSize: number;
};

export type ContractResponse = {
	contractId: string;
	categoryCode?: string | null;
	productCode?: string | null;
	partnerCode?: string | null;
	advisoryCaseId: string;
	status: ContractStatus;
	contractType?: ContractType | null;
	documents?: ContractDocumentResponse[] | null;
	essentials?: ContractEssentialsResponse | null;
};

export enum ContractStatus {
	Draft = "Draft",
	InProgress = "InProgress"
};

export enum ContractType {
	New = "New",
	Modification = "Modification"
};

export type ContractDocumentResponse = {
	documentId: string;
	documentType: string;
	dmsDocumentId: string;
};

export type ContractEssentialsResponse = {
	aml?: string | null;
	control?: string | null;
	provision?: string | null;
};

export enum ContractExpandFields {
	Documents = "Documents",
	Checks = "Checks"
};

export type CreateContractRequest = {
	advisoryCaseId: string;
	categoryCode?: string | null;
	productCode?: string | null;
	partnerCode?: string | null;
	status: ContractStatus;
	contractType?: ContractType | null;
};

export type UpdateContractRequest = {
	categoryCode?: string | null;
	productCode?: string | null;
	partnerCode?: string | null;
	status: ContractStatus;
	contractType?: ContractType | null;
};

export type RequiredDocumentResponse = {
	documentTypeCode: string;
	documentTypeName: string;
	conditions?: DocumentConditionResponse[] | null;
};

export type DocumentConditionResponse = {
	code: string;
	description: string;
};

export type ConsultantResponse = {
	id?: string | null;
	person?: PersonResponse | null;
	company?: CompanyResponse | null;
};

export type PersonResponse = {
	firstName?: string | null;
	lastName?: string | null;
	id?: string | null;
};

export type CompanyResponse = {
	name?: string | null;
	id?: string | null;
};

export type CommissionDistributionResponse = {
	commissionDistributionId: string;
	contractId: string;
	isConfirmed: boolean;
	confirmedAt?: string | null;
	confirmedByUserId?: number | null;
	participants: CommissionDistributionParticipantResponse[];
};

export type CommissionDistributionParticipantResponse = {
	commissionDistributionParticipantId: string;
	participantType: ParticipantType;
	consultantId: string;
	amount: number;
};

export enum ParticipantType {
	Realizator = "Realizator",
	ContractTipster = "ContractTipster",
	ClientTipster = "ClientTipster",
	InvitedSpecialist = "InvitedSpecialist"
};

export type UpsertCommissionDistributionApiRequest = {
	isConfirmed: boolean;
	participants: UpsertCommissionDistributionParticipantApiRequest[];
};

export type UpsertCommissionDistributionParticipantApiRequest = {
	commissionDistributionParticipantId?: string | null;
	participantType: ParticipantType;
	consultantId: string;
	amount: number;
};

export type CommissionDistributionConsultantResponse = {
	consultantId: string;
	fullName: string;
	position?: string | null;
	division?: string | null;
};

export type GetCodeListCollectionQueryResult = {
	countries: CodeListItemDto[];
};

export type CodeListItemDto = {
	id: number;
	code: string;
	name: string;
};

export type InvestmentQuestionnaireResponse = {
	uuid: string;
	id: number;
	createdAt: string;
};

export type SignUpCommandResult = {};

export type ApiProblemDetailsOfSignUpErrorStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum SignUpErrorStatus {
	UserExists = "UserExists"
};

export type ApiProblemDetailsOfPasswordChangeResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum PasswordChangeResultStatus {
	PasswordNotMatch = "PasswordNotMatch",
	NullOrEmpty = "NullOrEmpty",
	TooShort = "TooShort",
	Success = "Success"
};

export type SignUpCommand = {
	login: string;
	password: string;
};

export type SignInResult = {
	userInfo: UserInfo;
	isFirstSignIn: boolean;
};

export type UserInfo = {
	token: string;
	login: string;
	firstName: string;
	lastName: string;
	userIdentityProviders: IdentityProvider[];
	accessRightCodes: string[];
	profilePicture?: string | null;
};

export type ApiProblemDetailsOfAuthError = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum AuthError {
	ApplicationVerification = "ApplicationVerification",
	InvalidCredentials = "InvalidCredentials",
	AccountIsDisabled = "AccountIsDisabled",
	PhoneNumberNotFound = "PhoneNumberNotFound",
	SmsSendingFailed = "SmsSendingFailed",
	InvalidToken = "InvalidToken",
	AccountWaitingForEmailConfirmation = "AccountWaitingForEmailConfirmation"
};

export type SignInCommand = {
	login: string;
	password: string;
};

export type EmailVerificationCommandResult = {
	signInResult: SignInResult;
};

export type ApiProblemDetailsOfEmailVerificationCommandResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum EmailVerificationCommandResultStatus {
	TokenNotFound = "TokenNotFound",
	UserNotFound = "UserNotFound"
};

export type EmailVerificationCommand = {
	token: string;
};

export type ResendVerificationEmailCommandResult = {};

export type ResendVerificationEmailCommand = {
	email: string;
};

export type SsoSignInRequest = {
	token: string;
	identityProvider: IdentityProvider;
};

export type ResetPasswordCommandResult = {};

export type ApiProblemDetailsOfResetPasswordCommandResultStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum ResetPasswordCommandResultStatus {
	Fail = "Fail"
};

export type ResetPasswordCommand = {
	login: string;
};

export type SetPasswordCommandResult = {
	signInResult: SignInResult;
};

export type ApiProblemDetailsOfSetPasswordCommandStatus = {
	errors: { [key: string | number]: ErrorDetail[] };
	type?: string | null;
	title?: string | null;
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
};

export enum SetPasswordCommandStatus {
	TokenNotFound = "TokenNotFound"
};

export type SetPasswordCommand = {
	token: string;
	password: string;
};

export type CategoryToolsResponse = {
	categoryCode: string;
	tools: ToolResponse[];
	errorCode?: OpenLErrorCode | null;
};

export type ToolResponse = {
	code: string;
	name: string;
	description: string;
	order: number;
	isAvailable: boolean;
	unavailableReasons: string[];
};

export enum OpenLErrorCode {
	CategoryNotFound = "CategoryNotFound"
};

export type EntityListOfAdvisoryCaseResponse = {
	offset: number;
	limit: number;
	totalCount: number;
	items: AdvisoryCaseResponse[];
	pageNumber: number;
	pageSize: number;
};

export type AdvisoryCaseResponse = {
	advisoryCaseId: string;
	consultantId: string;
	clientId: number;
	contracts?: AdvisoryCaseContractResponse[] | null;
};

export type AdvisoryCaseContractResponse = {
	contractId: string;
	productType: ProductType;
	categoryCode?: string | null;
	productCode?: string | null;
	partnerCode?: string | null;
};

export enum ProductType {
	Unknown = "Unknown",
	Insurance = "Insurance",
	Investment = "Investment",
	Loan = "Loan",
	Savings = "Savings"
};

export enum AdvisoryCaseExpandFields {
	Contracts = "Contracts"
};

export type CreateAdvisoryCaseRequest = {
	consultantId: string;
	clientId: number;
};

export type UpdateAdvisoryCaseRequest = {
	consultantId: string;
	clientId: number;
};

export type GetUsersFetchResponse = 
| FetchResponse<EntityListOfUserListItemDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getUsersPath = () => `/api/v1/users`;

export const getUsers = (offset?: number, limit?: number, options?: FetchArgsOptions):
  Promise<GetUsersFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit
    }
    return apiGet(`${getApiUrl()}${getUsersPath()}`, options, queryParams) as Promise<GetUsersFetchResponse>;
}

export type GetUsersUserIDFetchResponse = 
| FetchResponse<UserDetailDto, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getUsersUserIDPath = (userID: number) => `/api/v1/users/${userID}`;

export const getUsersUserID = (userID: number, options?: FetchArgsOptions):
  Promise<GetUsersUserIDFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersUserIDPath(userID)}`, options, {}) as Promise<GetUsersUserIDFetchResponse>;
}

export type GetProductCatalogCategoriesFetchResponse = 
| FetchResponse<CategoryResponse[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const getProductCatalogCategoriesPath = () => `/api/v1/product-catalog/categories`;

export const getProductCatalogCategories = (options?: FetchArgsOptions):
  Promise<GetProductCatalogCategoriesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getProductCatalogCategoriesPath()}`, options, {}) as Promise<GetProductCatalogCategoriesFetchResponse>;
}

export type GetProductCatalogPartnersFetchResponse = 
| FetchResponse<PartnerResponse[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const getProductCatalogPartnersPath = () => `/api/v1/product-catalog/partners`;

export const getProductCatalogPartners = (categoryCode?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetProductCatalogPartnersFetchResponse> => {
    const queryParams = {
      "categoryCode": categoryCode
    }
    return apiGet(`${getApiUrl()}${getProductCatalogPartnersPath()}`, options, queryParams) as Promise<GetProductCatalogPartnersFetchResponse>;
}

export type GetProductCatalogProductsFetchResponse = 
| FetchResponse<ProductResponse[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const getProductCatalogProductsPath = () => `/api/v1/product-catalog/products`;

export const getProductCatalogProducts = (categoryCode?: string | undefined | null, partnerCode?: string | undefined | null, options?: FetchArgsOptions):
  Promise<GetProductCatalogProductsFetchResponse> => {
    const queryParams = {
      "categoryCode": categoryCode,
      "partnerCode": partnerCode
    }
    return apiGet(`${getApiUrl()}${getProductCatalogProductsPath()}`, options, queryParams) as Promise<GetProductCatalogProductsFetchResponse>;
}

export type PutNotificationsUserSettingsFetchResponse = 
| FetchResponse<SaveUserNotificationSettingsCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putNotificationsUserSettingsPath = () => `/api/v1/notifications/user-settings`;

export const putNotificationsUserSettings = (requestContract: UserNotificationUpdateRequest, options?: FetchArgsOptions):
  Promise<PutNotificationsUserSettingsFetchResponse> => {
    const requestData = getApiRequestData<UserNotificationUpdateRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putNotificationsUserSettingsPath()}`, requestData, options) as Promise<PutNotificationsUserSettingsFetchResponse>;
}

export type GetDocumentsDocumentIdDataFetchResponse = 
| FetchResponse<DocumentDataResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getDocumentsDocumentIdDataPath = (documentId: string) => `/api/v1/documents/${documentId}/data`;

export const getDocumentsDocumentIdData = (documentId: string, dataType?: DocumentDataType, options?: FetchArgsOptions):
  Promise<GetDocumentsDocumentIdDataFetchResponse> => {
    const queryParams = {
      "dataType": dataType
    }
    return apiGet(`${getApiUrl()}${getDocumentsDocumentIdDataPath(documentId)}`, options, queryParams) as Promise<GetDocumentsDocumentIdDataFetchResponse>;
}

export type GetDocumentsDocumentIdDataDocumentDataIdFetchResponse = 
| FetchResponse<DocumentDataResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getDocumentsDocumentIdDataDocumentDataIdPath = (documentDataId: string, documentId: string) => `/api/v1/documents/${documentId}/data/${documentDataId}`;

export const getDocumentsDocumentIdDataDocumentDataId = (documentDataId: string, documentId: string, options?: FetchArgsOptions):
  Promise<GetDocumentsDocumentIdDataDocumentDataIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getDocumentsDocumentIdDataDocumentDataIdPath(documentDataId, documentId)}`, options, {}) as Promise<GetDocumentsDocumentIdDataDocumentDataIdFetchResponse>;
}

export type GetDocumentsFetchResponse = 
| FetchResponse<EntityListOfDocumentResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getDocumentsPath = () => `/api/v1/documents`;

export const getDocuments = (offset?: number, limit?: number, contractId?: string | undefined | null, expand?: DocumentExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetDocumentsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "contractId": contractId,
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getDocumentsPath()}`, options, queryParams) as Promise<GetDocumentsFetchResponse>;
}

export type PostDocumentsFetchResponse = 
| FetchResponse<DocumentResponse, 201> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postDocumentsPath = () => `/api/v1/documents`;

export const postDocuments = (requestContract: CreateDocumentRequest, options?: FetchArgsOptions):
  Promise<PostDocumentsFetchResponse> => {
    const requestData = getApiRequestData<CreateDocumentRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postDocumentsPath()}`, requestData, options) as Promise<PostDocumentsFetchResponse>;
}

export type GetDocumentsIdFetchResponse = 
| FetchResponse<DocumentResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getDocumentsIdPath = (id: string) => `/api/v1/documents/${id}`;

export const getDocumentsId = (id: string, expand?: DocumentExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetDocumentsIdFetchResponse> => {
    const queryParams = {
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getDocumentsIdPath(id)}`, options, queryParams) as Promise<GetDocumentsIdFetchResponse>;
}

export type DeleteDocumentsIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const deleteDocumentsIdPath = (id: string) => `/api/v1/documents/${id}`;

export const deleteDocumentsId = (id: string, options?: FetchArgsOptions):
  Promise<DeleteDocumentsIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteDocumentsIdPath(id)}`, options, {}) as Promise<DeleteDocumentsIdFetchResponse>;
}

export type PutDocumentsIdFetchResponse = 
| FetchResponse<DocumentResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putDocumentsIdPath = (id: string) => `/api/v1/documents/${id}`;

export const putDocumentsId = (requestContract: UpdateDocumentRequest, id: string, options?: FetchArgsOptions):
  Promise<PutDocumentsIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateDocumentRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putDocumentsIdPath(id)}`, requestData, options) as Promise<PutDocumentsIdFetchResponse>;
}

export type PostDocumentsDocumentTypeExtractFetchResponse = 
| FetchResponse<SimplifiedExtractedDocumentResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postDocumentsDocumentTypeExtractPath = (documentType: string) => `/api/v1/documents/${documentType}/extract`;

export const postDocumentsDocumentTypeExtract = (documentType: string, options?: FetchArgsOptions):
  Promise<PostDocumentsDocumentTypeExtractFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, true);

    return apiPost(`${getApiUrl()}${postDocumentsDocumentTypeExtractPath(documentType)}`, requestData, options) as Promise<PostDocumentsDocumentTypeExtractFetchResponse>;
}

export type DeleteDocumentsDocumentIdContractsContractIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const deleteDocumentsDocumentIdContractsContractIdPath = (documentId: string, contractId: string) => `/api/v1/documents/${documentId}/contracts/${contractId}`;

export const deleteDocumentsDocumentIdContractsContractId = (documentId: string, contractId: string, options?: FetchArgsOptions):
  Promise<DeleteDocumentsDocumentIdContractsContractIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteDocumentsDocumentIdContractsContractIdPath(documentId, contractId)}`, options, {}) as Promise<DeleteDocumentsDocumentIdContractsContractIdFetchResponse>;
}

export type PostDocumentsDocumentIdContractsContractIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 409> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postDocumentsDocumentIdContractsContractIdPath = (documentId: string, contractId: string) => `/api/v1/documents/${documentId}/contracts/${contractId}`;

export const postDocumentsDocumentIdContractsContractId = (documentId: string, contractId: string, options?: FetchArgsOptions):
  Promise<PostDocumentsDocumentIdContractsContractIdFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postDocumentsDocumentIdContractsContractIdPath(documentId, contractId)}`, requestData, options) as Promise<PostDocumentsDocumentIdContractsContractIdFetchResponse>;
}

export type GetDocumentsDocumentIdContractsFetchResponse = 
| FetchResponse<EntityListOfContractResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getDocumentsDocumentIdContractsPath = (documentId: string) => `/api/v1/documents/${documentId}/contracts`;

export const getDocumentsDocumentIdContracts = (documentId: string, expand?: ContractExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetDocumentsDocumentIdContractsFetchResponse> => {
    const queryParams = {
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getDocumentsDocumentIdContractsPath(documentId)}`, options, queryParams) as Promise<GetDocumentsDocumentIdContractsFetchResponse>;
}

export type GetContractsFetchResponse = 
| FetchResponse<EntityListOfContractResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getContractsPath = () => `/api/v1/contracts`;

export const getContracts = (offset?: number, limit?: number, advisoryCaseId?: string | undefined | null, status?: ContractStatus[] | undefined | null, expand?: ContractExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetContractsFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "advisoryCaseId": advisoryCaseId,
      "status": status,
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getContractsPath()}`, options, queryParams) as Promise<GetContractsFetchResponse>;
}

export type PostContractsFetchResponse = 
| FetchResponse<ContractResponse, 201> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postContractsPath = () => `/api/v1/contracts`;

export const postContracts = (requestContract: CreateContractRequest, options?: FetchArgsOptions):
  Promise<PostContractsFetchResponse> => {
    const requestData = getApiRequestData<CreateContractRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postContractsPath()}`, requestData, options) as Promise<PostContractsFetchResponse>;
}

export type GetContractsIdFetchResponse = 
| FetchResponse<ContractResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getContractsIdPath = (id: string) => `/api/v1/contracts/${id}`;

export const getContractsId = (id: string, expand?: ContractExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetContractsIdFetchResponse> => {
    const queryParams = {
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getContractsIdPath(id)}`, options, queryParams) as Promise<GetContractsIdFetchResponse>;
}

export type DeleteContractsIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const deleteContractsIdPath = (id: string) => `/api/v1/contracts/${id}`;

export const deleteContractsId = (id: string, options?: FetchArgsOptions):
  Promise<DeleteContractsIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteContractsIdPath(id)}`, options, {}) as Promise<DeleteContractsIdFetchResponse>;
}

export type PutContractsIdFetchResponse = 
| FetchResponse<ContractResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putContractsIdPath = (id: string) => `/api/v1/contracts/${id}`;

export const putContractsId = (requestContract: UpdateContractRequest, id: string, options?: FetchArgsOptions):
  Promise<PutContractsIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateContractRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putContractsIdPath(id)}`, requestData, options) as Promise<PutContractsIdFetchResponse>;
}

export type GetContractsIdRequiredDocumentsFetchResponse = 
| FetchResponse<RequiredDocumentResponse[], 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getContractsIdRequiredDocumentsPath = (id: string) => `/api/v1/contracts/${id}/required-documents`;

export const getContractsIdRequiredDocuments = (id: string, options?: FetchArgsOptions):
  Promise<GetContractsIdRequiredDocumentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getContractsIdRequiredDocumentsPath(id)}`, options, {}) as Promise<GetContractsIdRequiredDocumentsFetchResponse>;
}

export type GetConsultantsFetchResponse = 
| FetchResponse<ConsultantResponse[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const getConsultantsPath = () => `/api/v1/consultants`;

export const getConsultants = (options?: FetchArgsOptions):
  Promise<GetConsultantsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getConsultantsPath()}`, options, {}) as Promise<GetConsultantsFetchResponse>;
}

export type GetContractsContractIdCommissionDistributionFetchResponse = 
| FetchResponse<CommissionDistributionResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getContractsContractIdCommissionDistributionPath = (contractId: string) => `/api/v1/contracts/${contractId}/commission-distribution`;

export const getContractsContractIdCommissionDistribution = (contractId: string, options?: FetchArgsOptions):
  Promise<GetContractsContractIdCommissionDistributionFetchResponse> => {
    return apiGet(`${getApiUrl()}${getContractsContractIdCommissionDistributionPath(contractId)}`, options, {}) as Promise<GetContractsContractIdCommissionDistributionFetchResponse>;
}

export type PutContractsContractIdCommissionDistributionFetchResponse = 
| FetchResponse<CommissionDistributionResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putContractsContractIdCommissionDistributionPath = (contractId: string) => `/api/v1/contracts/${contractId}/commission-distribution`;

export const putContractsContractIdCommissionDistribution = (requestContract: UpsertCommissionDistributionApiRequest, contractId: string, options?: FetchArgsOptions):
  Promise<PutContractsContractIdCommissionDistributionFetchResponse> => {
    const requestData = getApiRequestData<UpsertCommissionDistributionApiRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putContractsContractIdCommissionDistributionPath(contractId)}`, requestData, options) as Promise<PutContractsContractIdCommissionDistributionFetchResponse>;
}

export type GetCommissionDistributionConsultantsFetchResponse = 
| FetchResponse<CommissionDistributionConsultantResponse[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getCommissionDistributionConsultantsPath = () => `/api/v1/commission-distribution/consultants`;

export const getCommissionDistributionConsultants = (options?: FetchArgsOptions):
  Promise<GetCommissionDistributionConsultantsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCommissionDistributionConsultantsPath()}`, options, {}) as Promise<GetCommissionDistributionConsultantsFetchResponse>;
}

export type GetCodeListsFetchResponse = 
| FetchResponse<GetCodeListCollectionQueryResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getCodeListsPath = () => `/api/v1/code-lists`;

export const getCodeLists = (options?: FetchArgsOptions):
  Promise<GetCodeListsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCodeListsPath()}`, options, {}) as Promise<GetCodeListsFetchResponse>;
}

export type GetClientsClientIdInvestmentQuestionnaireFetchResponse = 
| FetchResponse<InvestmentQuestionnaireResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ApiProblemDetails, 422> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getClientsClientIdInvestmentQuestionnairePath = (clientId: number) => `/api/v1/clients/${clientId}/investment-questionnaire`;

export const getClientsClientIdInvestmentQuestionnaire = (clientId: number, options?: FetchArgsOptions):
  Promise<GetClientsClientIdInvestmentQuestionnaireFetchResponse> => {
    return apiGet(`${getApiUrl()}${getClientsClientIdInvestmentQuestionnairePath(clientId)}`, options, {}) as Promise<GetClientsClientIdInvestmentQuestionnaireFetchResponse>;
}

export type PostAuthSignUpFetchResponse = 
| FetchResponse<SignUpCommandResult, 201> 
| FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfSignUpErrorStatus, 409> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthSignUpPath = () => `/api/v1/auth/sign-up`;

export const postAuthSignUp = (requestContract: SignUpCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignUpFetchResponse> => {
    const requestData = getApiRequestData<SignUpCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignUpPath()}`, requestData, options) as Promise<PostAuthSignUpFetchResponse>;
}

export type PostAuthSignInFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetailsOfAuthError, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthSignInPath = () => `/api/v1/auth/sign-in`;

export const postAuthSignIn = (requestContract: SignInCommand, options?: FetchArgsOptions):
  Promise<PostAuthSignInFetchResponse> => {
    const requestData = getApiRequestData<SignInCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSignInPath()}`, requestData, options) as Promise<PostAuthSignInFetchResponse>;
}

export type PostAuthEmailVerificationFetchResponse = 
| FetchResponse<EmailVerificationCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfEmailVerificationCommandResultStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthEmailVerificationPath = () => `/api/v1/auth/email-verification`;

export const postAuthEmailVerification = (requestContract: EmailVerificationCommand, options?: FetchArgsOptions):
  Promise<PostAuthEmailVerificationFetchResponse> => {
    const requestData = getApiRequestData<EmailVerificationCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthEmailVerificationPath()}`, requestData, options) as Promise<PostAuthEmailVerificationFetchResponse>;
}

export type PostAuthEmailVerificationSendFetchResponse = 
| FetchResponse<ResendVerificationEmailCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthEmailVerificationSendPath = () => `/api/v1/auth/email-verification/send`;

export const postAuthEmailVerificationSend = (requestContract: ResendVerificationEmailCommand, options?: FetchArgsOptions):
  Promise<PostAuthEmailVerificationSendFetchResponse> => {
    const requestData = getApiRequestData<ResendVerificationEmailCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthEmailVerificationSendPath()}`, requestData, options) as Promise<PostAuthEmailVerificationSendFetchResponse>;
}

export type PostAuthSsoFetchResponse = 
| FetchResponse<SignInResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfAuthError, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthSsoPath = () => `/api/v1/auth/sso`;

export const postAuthSso = (requestContract: SsoSignInRequest, options?: FetchArgsOptions):
  Promise<PostAuthSsoFetchResponse> => {
    const requestData = getApiRequestData<SsoSignInRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthSsoPath()}`, requestData, options) as Promise<PostAuthSsoFetchResponse>;
}

export type PostAuthPasswordResetFetchResponse = 
| FetchResponse<ResetPasswordCommandResult, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfResetPasswordCommandResultStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAuthPasswordResetPath = () => `/api/v1/auth/password-reset`;

export const postAuthPasswordReset = (requestContract: ResetPasswordCommand, options?: FetchArgsOptions):
  Promise<PostAuthPasswordResetFetchResponse> => {
    const requestData = getApiRequestData<ResetPasswordCommand>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAuthPasswordResetPath()}`, requestData, options) as Promise<PostAuthPasswordResetFetchResponse>;
}

export type PutAuthPasswordFetchResponse = 
| FetchResponse<SetPasswordCommandResult, 200> 
| FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetailsOfSetPasswordCommandStatus, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putAuthPasswordPath = () => `/api/v1/auth/password`;

export const putAuthPassword = (requestContract: SetPasswordCommand, options?: FetchArgsOptions):
  Promise<PutAuthPasswordFetchResponse> => {
    const requestData = getApiRequestData<SetPasswordCommand>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAuthPasswordPath()}`, requestData, options) as Promise<PutAuthPasswordFetchResponse>;
}

export type GetAuthUserinfoFetchResponse = 
| FetchResponse<UserInfo, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getAuthUserinfoPath = () => `/api/v1/auth/userinfo`;

export const getAuthUserinfo = (options?: FetchArgsOptions):
  Promise<GetAuthUserinfoFetchResponse> => {
    return apiGet(`${getApiUrl()}${getAuthUserinfoPath()}`, options, {}) as Promise<GetAuthUserinfoFetchResponse>;
}

export type GetAdvisoryToolsFetchResponse = 
| FetchResponse<CategoryToolsResponse[], 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| FetchResponse<ApiProblemDetails, 503> 
| ErrorResponse;

export const getAdvisoryToolsPath = () => `/api/v1/advisory-tools`;

export const getAdvisoryTools = (categories?: string[], options?: FetchArgsOptions):
  Promise<GetAdvisoryToolsFetchResponse> => {
    const queryParams = {
      "categories": categories
    }
    return apiGet(`${getApiUrl()}${getAdvisoryToolsPath()}`, options, queryParams) as Promise<GetAdvisoryToolsFetchResponse>;
}

export type GetAdvisoryCasesFetchResponse = 
| FetchResponse<EntityListOfAdvisoryCaseResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getAdvisoryCasesPath = () => `/api/v1/advisory-cases`;

export const getAdvisoryCases = (offset?: number, limit?: number, expand?: AdvisoryCaseExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetAdvisoryCasesFetchResponse> => {
    const queryParams = {
      "offset": offset,
      "limit": limit,
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getAdvisoryCasesPath()}`, options, queryParams) as Promise<GetAdvisoryCasesFetchResponse>;
}

export type PostAdvisoryCasesFetchResponse = 
| FetchResponse<AdvisoryCaseResponse, 201> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const postAdvisoryCasesPath = () => `/api/v1/advisory-cases`;

export const postAdvisoryCases = (requestContract: CreateAdvisoryCaseRequest, options?: FetchArgsOptions):
  Promise<PostAdvisoryCasesFetchResponse> => {
    const requestData = getApiRequestData<CreateAdvisoryCaseRequest>(requestContract, false);

    return apiPost(`${getApiUrl()}${postAdvisoryCasesPath()}`, requestData, options) as Promise<PostAdvisoryCasesFetchResponse>;
}

export type GetAdvisoryCasesIdFetchResponse = 
| FetchResponse<AdvisoryCaseResponse, 200> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const getAdvisoryCasesIdPath = (id: string) => `/api/v1/advisory-cases/${id}`;

export const getAdvisoryCasesId = (id: string, expand?: AdvisoryCaseExpandFields[] | undefined | null, options?: FetchArgsOptions):
  Promise<GetAdvisoryCasesIdFetchResponse> => {
    const queryParams = {
      "expand": expand
    }
    return apiGet(`${getApiUrl()}${getAdvisoryCasesIdPath(id)}`, options, queryParams) as Promise<GetAdvisoryCasesIdFetchResponse>;
}

export type DeleteAdvisoryCasesIdFetchResponse = 
| FetchResponse<void, 204> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const deleteAdvisoryCasesIdPath = (id: string) => `/api/v1/advisory-cases/${id}`;

export const deleteAdvisoryCasesId = (id: string, options?: FetchArgsOptions):
  Promise<DeleteAdvisoryCasesIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteAdvisoryCasesIdPath(id)}`, options, {}) as Promise<DeleteAdvisoryCasesIdFetchResponse>;
}

export type PutAdvisoryCasesIdFetchResponse = 
| FetchResponse<AdvisoryCaseResponse, 200> 
| FetchResponse<ApiProblemDetails, 400> 
| FetchResponse<ApiProblemDetails, 401> 
| FetchResponse<ApiProblemDetails, 404> 
| FetchResponse<ProblemDetails, 500> 
| ErrorResponse;

export const putAdvisoryCasesIdPath = (id: string) => `/api/v1/advisory-cases/${id}`;

export const putAdvisoryCasesId = (requestContract: UpdateAdvisoryCaseRequest, id: string, options?: FetchArgsOptions):
  Promise<PutAdvisoryCasesIdFetchResponse> => {
    const requestData = getApiRequestData<UpdateAdvisoryCaseRequest>(requestContract, false);

    return apiPut(`${getApiUrl()}${putAdvisoryCasesIdPath(id)}`, requestData, options) as Promise<PutAdvisoryCasesIdFetchResponse>;
}
